import React from 'react'
import getLegendText from './functions/getLegendText'

export default function ProgressChartBenchmarkLegend(props) {

    const { shouldShowChart, poorCutoff, averageCutoff, goodCutoff, selectedEquating, selectedBenchmark, customBenchmarks, embedded } = props

    if(!shouldShowChart) return null
    if(!poorCutoff || !averageCutoff || !goodCutoff) return null
    if(!poorCutoff.length || !averageCutoff.length || !goodCutoff.length) return null
    if(!selectedEquating) return null 
    if(embedded) return null
    const legendText = getLegendText(selectedBenchmark, customBenchmarks )
    
    return (
        <div className="progressBenchmarkLegend">
            <div className='progressLegendSubheader'>
                <span>{legendText.title}</span> <br /> {legendText.subtitle}
            </div>
            <div className='progressLegendItems'>
                <div className='progressLegendItem'>
                    <div className='progressLegendSquare great'> </div>
                    <div className='multilineItem legendLabel'><span> Above </span> <br />{legendText.green}</div>
                </div>
                <div className='progressLegendItem paddedLegendItem'>
                    <div className='progressLegendSquare average'> </div>
                    <div className="legendLabel">{legendText.yellow}</div>
                </div>
                <div className='progressLegendItem'>
                    <div className='progressLegendSquare poor'> </div>
                    <div className='multilineItem legendLabel'><span> Below </span> <br />{legendText.red}</div>
                </div>
            </div>
        </div>
    )
}
